import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const StyledFileInputLabel = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'inputBtnComponent',
})(() => ({
  '.MuiInputLabel-root': {
    display: 'flex',
    padding: '52px 66px',
    border: '1px dashed #BEC4CE',
    borderRadius: '10px',
    cursor: 'pointer',
  },
}));
